export default "__VITE_ASSET__BBXZCjTX__"